import { useCallback } from 'react';
import { useMutation } from 'src/graphql';
import { EDIT_COUNTRY_VERSION_MUTATION } from 'src/graphql/country/mutation';

export default () => {
  const [editCountryVersion] = useMutation(EDIT_COUNTRY_VERSION_MUTATION);

  return useCallback(
    ({ countryId, name, code2, code3, publish, ...rest }) =>
      editCountryVersion({
        variables: {
          countryId,
          name,
          code2,
          code3,
          publish,
          ...rest,
        },
      }),
    [],
  );
};
